<script setup>
import { computed } from 'vue'

import { AdvertorialBadge } from '@toni/brand-ui'

import { usePageStore } from '../../stores/page'

const pageStore = usePageStore()
const adaAutoNative = computed(() => {
  const metaData = pageStore.pageData?.metaData
  return metaData?.adaAutoNative === true
})
</script>

<template>
  <AdvertorialBadge class="my-10 pb-6 md:mt-10 md:mb-16 md:pb-0 text-ui-xs text-secondary-foreground"
                    :data-ems="adaAutoNative ? 'ems-native-adlabel' : null">
    {{ $t('ads.advertorialBadge') }}
  </AdvertorialBadge>
</template>
